import { css } from "@emotion/css"
import React from "react"

type Props = {
  children: React.ReactElement | React.ReactElement[]
}

const NestedList = ({ children }: Props) => {
  const additionalProps = {
    className: styles.item,
    hoverClassName: styles.itemHover,
  }

  return (
    <ul className={styles.list}>
      {React.Children.map(children, (child) => React.cloneElement(child, additionalProps))}
    </ul>
  )
}

export default NestedList

const styles = {
  list: css`
    list-style: none;
    border: 10px solid #cbe8cc;
    border-top: none;
    > li {
      &:not(:first-child)::before,
      &:not(:last-child)::after {
        width: 100%;
        margin: 0;
      }
    }
  `,
  item: css`
    font-weight: normal;
  `,
  itemHover: css`
    background-color: #defadf;
  `,
}
